import deserialize from 'app/utils/deserialize'
import { fetch } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    monthly: [],
    monthlyProducts: [],
    quarterly: [],
    quarterlyProducts: [],
    yearly: [],
    yearlyProducts: []
  },

  getters: {
    currentMonthly: (state) => state.monthly,

    currentMonthlyProducts: (state) => state.monthlyProducts,

    currentQuarterly: (state) => state.quarterly,

    currentQuarterlyProducts: (state) => state.quarterlyProducts,

    currentYearly: (state) => state.yearly,

    currentYearlyProducts: (state) => state.yearlyProducts
  },

  mutations: {
    monthlyFetched(state, { monthly }) {
      state.monthly = monthly
    },

    monthlyProductsFetched(state, { monthlyProducts }) {
      state.monthlyProducts = monthlyProducts
    },

    quarterlyFetched(state, { quarterly }) {
      state.quarterly = quarterly
    },

    quarterlyProductsFetched(state, { quarterlyProducts }) {
      state.quarterlyProducts = quarterlyProducts
    },

    yearlyFetched(state, { yearly }) {
      state.yearly = yearly
    },

    yearlyProductsFetched(state, { yearlyProducts }) {
      state.yearlyProducts = yearlyProducts
    },

    resetState(state) {
      state.monthly = []
      state.monthlyProducts = []
      state.quarterly = []
      state.quarterlyProducts = []
      state.yearly = []
      state.yearlyProducts = []
    }
  },

  actions: {
    fetchMonthly({ commit }, { month, year }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: `/api/admin/reports/monthly`,
          params: {
            month,
            year
          }
        })
          .then((response) => {
            deserialize(response.data).then((monthly) => {
              commit('monthlyFetched', { monthly })
              resolve(monthly)
            })
          })
          .catch(() => {
            reject()
          })
      })
    },

    fetchMonthlyProducts({ commit }, { month, year }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: `/api/admin/reports/monthly-products`,
          params: {
            month,
            year
          }
        })
          .then((response) => {
            deserialize(response.data).then((monthlyProducts) => {
              commit('monthlyProductsFetched', { monthlyProducts })
              resolve(monthlyProducts)
            })
          })
          .catch(() => {
            reject()
          })
      })
    },

    fetchQuarterly({ commit }, { quarter, year }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: `/api/admin/reports/quarterly`,
          params: {
            quarter,
            year
          }
        })
          .then((response) => {
            deserialize(response.data).then((quarterly) => {
              commit('quarterlyFetched', { quarterly })
              resolve(quarterly)
            })
          })
          .catch(() => {
            reject()
          })
      })
    },

    fetchQuarterlyProducts({ commit }, { quarter, year }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: `/api/admin/reports/quarterly-products`,
          params: {
            quarter,
            year
          }
        })
          .then((response) => {
            deserialize(response.data).then((quarterlyProducts) => {
              commit('quarterlyProductsFetched', { quarterlyProducts })
              resolve(quarterlyProducts)
            })
          })
          .catch(() => {
            reject()
          })
      })
    },

    fetchYearly({ commit }, { year }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: `/api/admin/reports/yearly`,
          params: {
            year
          }
        })
          .then((response) => {
            deserialize(response.data).then((yearly) => {
              commit('yearlyFetched', { yearly })
              resolve(yearly)
            })
          })
          .catch(() => {
            reject()
          })
      })
    },

    fetchYearlyProducts({ commit }, { year }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: `/api/admin/reports/yearly-products`,
          params: {
            year
          }
        })
          .then((response) => {
            deserialize(response.data).then((yearlyProducts) => {
              commit('yearlyProductsFetched', { yearlyProducts })
              resolve(yearlyProducts)
            })
          })
          .catch(() => {
            reject()
          })
      })
    }
  }
}
